import { useEffect, useState } from "react";
import { authClient } from "@/lib/auth";
import { MessageCircle } from "lucide-react";

export default function DiscordWidget() {
  const [d, setD] = useState(null);
  useEffect(() => {
    authClient.get("/discord/live").then((r) => setD(r.data)).catch(() => {});
  }, []);
  if (!d) return null;
  return (
    <div className="rounded-2xl glass p-5" data-testid="discord-widget">
      <div className="flex items-center gap-2 mb-3">
        <MessageCircle size={14} className="text-[#5865F2]" />
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#5865F2]">Discord</div>
        {d.source === "mock" && <span className="text-[9px] text-white/30 ml-auto">demo</span>}
      </div>
      <div className="flex items-center gap-3">
        {d.icon && <img src={d.icon} alt="" className="w-10 h-10 rounded-xl" />}
        <div>
          <div className="font-semibold">{d.name}</div>
          <div className="text-xs text-white/60 flex items-center gap-3">
            <span className="inline-flex items-center gap-1"><span className="w-2 h-2 rounded-full bg-green-500" /> {d.online ?? 0} online</span>
            <span>{d.members ?? 0} members</span>
          </div>
        </div>
      </div>
      <a href={d.invite || "https://discord.gg/lostdc"} target="_blank" rel="noreferrer"
        data-testid="discord-join"
        className="mt-3 block text-center py-2 rounded-full bg-[#5865F2] hover:bg-[#4752C4] text-white text-xs font-semibold uppercase tracking-wider transition-colors">
        Join Server
      </a>
    </div>
  );
}
